import { Link } from 'react-router-dom';

// Page d'accueil avec hero, about, skills, projets, blog preview
function Home() {
    return (
        <>
            {/* Hero */}
            <section className="flex flex-col items-center justify-center text-center py-32 px-8">
                <h1 className="text-5xl font-bold mb-4">Hi, I'm Guillaume</h1>
                <p className="text-xl text-gray-400 mb-8">Software Developer</p>
                <Link to="/blogs" className="bg-blue-600 hover:bg-blue-500 text-white px-6 py-3 rounded-lg font-semibold">View Blog</Link>
            </section>

            {/* About */}
            <section className="max-w-4xl mx-auto px-8 py-16">
                <h2 className="text-3xl font-bold mb-6 text-blue-400">About Me</h2>
                <p className="text-gray-400 leading-relaxed">Passionate software developer with a focus on building clean, efficient web applications. Currently studying fullstack development and exploring modern technologies.</p>
            </section>

            {/* Skills */}
            <section className="max-w-4xl mx-auto px-8 py-16">
                <h2 className="text-3xl font-bold mb-6 text-blue-400">Skills</h2>
                <div className="flex flex-wrap gap-3">
                    {['JavaScript', 'React', 'Node.js', 'Express', 'PostgreSQL', 'MongoDB', 'TailwindCSS', 'Git'].map(skill => (
                        <span key={skill} className="bg-gray-800 border border-gray-700 px-4 py-2 rounded-lg text-sm">{skill}</span>
                    ))}
                </div>
            </section>

            {/* Projets preview */}
            <section className="max-w-4xl mx-auto px-8 py-16">
                <h2 className="text-3xl font-bold mb-6 text-blue-400">Projects</h2>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    <div className="bg-gray-900 border border-gray-800 rounded-xl p-6 hover:border-blue-500 transition">
                        <h3 className="text-lg font-bold mb-2">To-Do App</h3>
                        <p className="text-gray-400 text-sm">Mood-based task manager with weather integration.</p>
                    </div>
                    <div className="bg-gray-900 border border-gray-800 rounded-xl p-6 hover:border-blue-500 transition">
                        <h3 className="text-lg font-bold mb-2">REST API</h3>
                        <p className="text-gray-400 text-sm">Backend API with Node.js, Express, and PostgreSQL.</p>
                    </div>
                    <div className="bg-gray-900 border border-gray-800 rounded-xl p-6 hover:border-blue-500 transition">
                        <h3 className="text-lg font-bold mb-2">Blog Platform</h3>
                        <p className="text-gray-400 text-sm">Full-stack blog with React and PostgreSQL.</p>
                    </div>
                </div>
            </section>
        </>
    );
}

export default Home;